<template>
    <form class="add-review-form" @submit.prevent="onSubmit">

        <div class="add-review-form__header">
            <button class="close" @click.prevent="closeForm">
                <svg width="24" height="24">
                    <use xlink:href="/sprite.svg#icon-close"></use>
                </svg>
            </button>

            <h5 class="add-review-form__title">Новый отзыв</h5>
        </div>

        <div class="add-review-form__row">
          <div class="add-review-form__label">Ваша оценка</div>
          <div class="add-review-form__rating">
                <rating-input v-model="reviewRating" @input="error = !reviewRating"/>
                <div class="add-review-form__error" v-if="error">
                   Укажите оценку
                </div>
          </div>
        </div>

        <div class="add-review-form__row">
          <div class="add-review-form__label">Отзыв</div>
          <textarea class="add-review-form__input add-review-form__input--textarea" v-model="reviewText"></textarea>
        </div>

        <div class="add-review-form__btn">
          <button class="btn btn-outline-main btn-block">Оставить отзыв</button>
        </div>

         <transition name="fade">
            <div class="add-review-form__spinner" v-if="isLoading">
                <div class="spinner-border text-main" role="status" />
            </div>
        </transition>

      </form>
</template>

<script>
import * as ajaxService from '../../services/ajax-service';

import RatingInput from '../common/fields/rating-input';
import { globalErrorHandler } from '../../services/error-handling';

export default {
    name: 'add-review-form',
    data() {
        return {
            reviewRating: null,
            reviewText: null,
            isLoading: false,
            error: false,
        };
    },
    props: {
        product: {
            required: true,
            type: Number,
        },
    },
    components: {
        RatingInput,
    },
    methods: {
        closeForm() {
            this.$emit('close');
        },
        onSubmit() {
            this.error = !this.reviewRating;
            if (this.reviewRating) {
                if (this.reviewText) {
                    this.sendReview();
                    return;
                }
                this.sendRatind();
            }
        },
        async sendRatind() {
            this.isLoading = true;

            try {
                const { data } = await ajaxService.post('/api/rating/add/', {
                    data: {
                        product: this.product,
                        // rating: this.reviewRating,
                    },
                });

                this.$emit('send', data);
            } catch (error) {
                globalErrorHandler(error);
            } finally {
                this.isLoading = false;
            }
        },
        async sendReview() {
            this.isLoading = true;

            try {
                const { data } = await ajaxService.post('/api/review/add/', {
                    data: {
                        product: this.product,
                        rating: this.reviewRating,
                        review: this.reviewText,
                    },
                });
                this.$emit('send', data);
            } catch (error) {
                globalErrorHandler(error);
                this.$emit('send', error);
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
